var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5904 10.3377C17.5904 8.96359 17.0445 7.64581 16.0729 6.67419C15.1013 5.70258 13.7835 5.15674 12.4094 5.15674C11.0354 5.15674 9.71758 5.70258 8.74597 6.67419C7.77436 7.64581 7.22852 8.96359 7.22852 10.3377C7.22852 11.7117 7.77436 13.0295 8.74597 14.0011C9.71758 14.9727 11.0354 15.5186 12.4094 15.5186C13.7835 15.5186 15.1013 14.9727 16.0729 14.0011C17.0445 13.0295 17.5904 11.7117 17.5904 10.3377Z",
    stroke: "white",
    strokeWidth: 1.65789,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 22.7714C5.156 21.5476 5.46538 20.3437 6.05559 19.2717C6.6458 18.1996 7.49766 17.2944 8.53186 16.6401C9.56606 15.9859 10.749 15.604 11.9705 15.5299C13.192 15.4558 14.4124 15.692 15.5181 16.2165M21.2171 23.2895C22.1808 23.2895 23.0201 22.7641 23.4667 21.9839M21.2171 23.2895C20.2535 23.2895 19.4141 22.7641 18.9675 21.9839M21.2171 23.2895V24.8438M23.4667 21.9839L24.8437 22.7714M23.4667 21.9839C23.6832 21.6057 23.8076 21.1674 23.8076 20.699C23.8076 20.2307 23.6832 19.7924 23.4656 19.4142M18.9675 21.9839L17.5905 22.7714M18.9675 21.9839C18.7441 21.5925 18.6266 21.1497 18.6266 20.699C18.6266 20.2317 18.751 19.7924 18.9686 19.4142M21.2171 18.1086C22.1808 18.1086 23.0201 18.6339 23.4656 19.4142M21.2171 18.1086C20.2535 18.1086 19.4141 18.6339 18.9686 19.4142M21.2171 18.1086V16.5543M23.4656 19.4142L24.8437 18.6267M18.9686 19.4142L17.5905 18.6267",
    stroke: "white",
    strokeWidth: 1.65789,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/User Management.3809efd8d7667bf5927d8cb0da403f8c.svg";
export { ForwardRef as ReactComponent };